import { createContext } from "preact";

const Resize = createContext();

export { Resize };
